<div class="container">

  <mat-tab-group>
    @if (data.action == 'cve' ) {
      <mat-tab label="Informacion">
        <div class="w-100 d-flex flex-column" style="height: 90vh;">
          <div class="d-flex flex-column flex-sm-row w-100 justify-content-between">
            <div class="w-100 w-sm-50 d-flex align-items-center justify-content-center" style="padding: 20px;">
              <div class="img">
                <file-input class="mat-elevation-z2" [params]='fileInputEquipo'></file-input>
              </div>
            </div>
            <div class="w-100 w-sm-50 container-info">
              <h3 class="mat-elevation-z2" ><strong>Código: </strong> {{data.dataEquipo.code}}</h3>
              <h3 class="mat-elevation-z2" ><strong>Marca: </strong> {{data.dataEquipo.brand}}</h3>
              <h3 class="mat-elevation-z2"><strong>Area: </strong> {{data.dataEquipo.areaName}}</h3>
              <h3 class="mat-elevation-z2"><strong>Fecha de fabricacion: </strong> {{data.dataEquipo.fabricationDate}}</h3>
              <h3 class="mat-elevation-z2"><strong>Medidor actual (horas/km/ciclos): </strong> {{data.dataEquipo.currentOdometer | thousandSeparator}}</h3>
              <h3 class="mat-elevation-z2"><strong>Tipo Equipo: </strong> {{data.dataEquipo.equipmentTypeName}}</h3>
            </div>
          </div>
          <div class="d-flex flex-column flex-sm-row" >
            <div class="w-100 w-sm-50 container-info">
              <h3 class="mat-elevation-z2"><strong>Potencia: </strong> {{data.dataEquipo.power}}</h3>
              <h3 class="mat-elevation-z2"><strong> Alimentación: </strong> {{data.dataEquipo.powerSupply}}</h3>
              <h3 class="mat-elevation-z2"><strong>Serial: </strong> {{data.dataEquipo.serial}}</h3>
              <h3 class="mat-elevation-z2"><strong>Color: </strong> {{data.dataEquipo.color}}</h3>
              <h3 class="mat-elevation-z2"><strong>Accesorios: </strong> {{data.dataEquipo.accessories}}</h3>
              <h3 class="mat-elevation-z2"><strong>Creada por: </strong> {{data.dataEquipo.createdBy}}</h3>
              <h3 class="mat-elevation-z2"><strong>Fecha creación: </strong> {{data.dataEquipo.created | dateFormat}}</h3>
            </div>
            <div class="w-100 w-sm-50 container-info">
              <h3 class="mat-elevation-z2"><strong>Responsable: </strong> {{data.dataEquipo.userName}}</h3>
              <h3 class="mat-elevation-z2"><strong>Proveedor: </strong> {{data.dataEquipo.providerName}}</h3>
              <h3 class="mat-elevation-z2"><strong>Garantía: </strong> {{data.dataEquipo.warranty}}</h3>
              <h3 class="mat-elevation-z2"><strong>Aplicación:</strong> {{data.dataEquipo.aplication}}</h3>
              <h3 class="mat-elevation-z2"><strong>Descripción: </strong> {{data.dataEquipo.description}}</h3>
              <h3 class="mat-elevation-z2"><strong>Actualizada por: </strong> {{data.dataEquipo.updatedBy}}</h3>
              <h3 class="mat-elevation-z2"><strong>Fecha actualización: </strong> {{data.dataEquipo.updated | dateFormat}}</h3>
            </div>
          </div>
        </div>
      </mat-tab>
    }

    @if (dataComponentes.length > 0) {
      <mat-tab  [label]="titleLabel">
        <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
          <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center;">
            @for (item of dataComponentes; track item) {
              <div >
                @if (item.name == 'Trailer') {
                  <mat-card appearance="outlined" style="background: transparent;" class="example-card">
                    <mat-card-header>
                      <mat-card-subtitle>Nombre: {{item.name}}</mat-card-subtitle>
                    </mat-card-header>
                    <img mat-card-image [src]="item.photo">
                    <mat-card-content>
                      <p>
                        Especificaciones: {{item.specifications}}
                      </p>
                    </mat-card-content>
                  </mat-card>
                }
              </div>
            }
            <div style="margin: 30px; width: 100%;" >
              <data-table
                [title]='titleComponentes'
                [columns]='columnasComponentes'
                [data]='dataComponentes'
                [configuration]='configurationComponentes'
                [reloadTable]='recargarTablaComponentes'
                [url]='urlGetComponentes'
                [params]='paramsCompoentes'
              ></data-table>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </mat-tab>
    }

  </mat-tab-group>

</div>
